import PropTypes from "prop-types";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu";
import images from "../../assets/images";
import PremiseDropdown from "../CommonForBoth/TopbarDropdown/PremiseDropdown";

const Header = (props) => {
  function tToggle() {
    var body = document.body;
    if (window.screen.width <= 998) {
      body.classList.toggle("sidebar-enable");
    } else {
      body.classList.toggle("vertical-collpsed");
      body.classList.toggle("sidebar-enable");
    }
  }

  return (
    <React.Fragment>
      <header id="page-topbar" style={{ backgroundColor: "#0E0E0E" }}>
        <div className="navbar-header">
          <div className="d-flex">
            <div className="navbar-brand-box d-lg-none d-md-block">
              <Link to="/" className="logo logo-dark">
                <span className="logo-sm">
                  <img
                    src={images.logo}
                    alt=""
                    height="40"
                    style={{ borderRadius: 4 }}
                  />
                </span>
              </Link>

              <Link to="/" className="logo logo-light">
                <span className="logo-sm">
                  <img
                    src={images.logo}
                    alt=""
                    height="40"
                    style={{ borderRadius: 4 }}
                  />
                </span>
              </Link>
            </div>

            <button
              type="button"
              onClick={() => {
                tToggle();
              }}
              className="btn btn-sm px-3 font-size-16 header-item "
              id="vertical-menu-btn"
            >
              <box-icon name="menu" color="white"></box-icon>
            </button>
            <div
              style={{
                // width: '100%',
                marginTop: 7,
                alignItems: "center",
                justifyContent: "center",
                display: "flex",
              }}
            >
              <h5 style={{ color: "#fff", fontWeight: "bold", fontSize: 17 }}>
                {props.activeRoute}
              </h5>
            </div>
          </div>

          <div className="d-flex">
            <PremiseDropdown />
          </div>
          <div className="d-flex">
            <ProfileMenu />
          </div>
        </div>
      </header>
    </React.Fragment>
  );
};

Header.propTypes = {
  changeSidebarType: PropTypes.func,
  leftMenu: PropTypes.any,
  leftSideBarType: PropTypes.any,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func,
};

export default Header;
